// realtime
const state = {
  loading: false,
  baseStationData: [
    {
      id: 1,
      name: "Songkhla",
      mmsi: "2579901",
      sn: "STX554949511029"
    },
    {
      id: 2,
      name: "Satun",
      mmsi: "2579902",
      sn: "STX579752515052"
    },
    {
      id: 3,
      name: "Chumphon",
      mmsi: "2579903",
      sn: "STX101505049555"
    },
    {
      id: 4,
      name: "Petchaburi",
      mmsi: "2579904",
      sn: "STX555153579910"
    },
    {
      id: 5,
      name: "Nakhonsri Thammarat",
      mmsi: "2579905",
      sn: "STX541015252529"
    },
    {
      id: 6,
      name: "Prachaup Khirikhan",
      mmsi: "2579906",
      sn: "STX491005610052"
    },
    {
      id: 7,
      name: "Samut Prakarn",
      mmsi: "2579907",
      sn: "4.09-6500-01986"
    },
    {
      id: 8,
      name: "Chonburi",
      mmsi: "2579908",
      sn: "STX491005410055"
    },
    {
      id: 9,
      name: "Rayong",
      mmsi: "2579909",
      sn: ""
    },
    {
      id: 10,
      name: "Phuket",
      mmsi: "25799910",
      sn: "STX555699989957"
    },
    {
      id: 11,
      name: "Ranong",
      mmsi: "2579911",
      sn: "STX561025648554"
    },
    {
      id: 12,
      name: "Surat Samui",
      mmsi: "2579912",
      sn: "STX491005610052"
    },
    {
      id: 13,
      name: "Surat Thani",
      mmsi: "2579913",
      sn: "STX100485049555"
    }
  ]
};

const getters = {
  baseStationData: state => state.baseStationData,
  loading: state => state.loading
};

const actions = {};

const mutations = {
  REALTIME_LOADING(state, payload) {
    state.loading = payload.loading;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
